import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sparkles, X } from "lucide-react";

// Free-plan nudge. Shown to Free-tier workspaces (Pro is hidden). The full
// migration/estate workflow is Pro-only; Free is the troubleshooting-first tier.
export const TrialBanner = () => {
  const { user, isPro, entitlements } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(sessionStorage.getItem("ucmp_free_dismissed") === "1");

  if (!user || isPro || dismissed) return null;

  const remaining = entitlements?.ai_remaining_today;
  const dismiss = () => { sessionStorage.setItem("ucmp_free_dismissed", "1"); setDismissed(true); };

  return (
    <div
      data-testid="free-plan-banner"
      className="no-print flex items-center gap-3 px-5 sm:px-8 py-2.5 border-b text-[13px] bg-blue-500/10 border-blue-500/25 text-blue-100"
    >
      <Sparkles className="h-4 w-4 shrink-0 text-blue-400" />
      <span className="flex-1 leading-snug">
        <span className="font-semibold">You're on the Free plan.</span>{" "}
        Full troubleshooting &amp; AI diagnostics
        {typeof remaining === "number" ? ` (${remaining} AI request${remaining === 1 ? "" : "s"} left today)` : ""}.
        Unlock production migrations, waves, GO/NO-GO gates, number porting, exports &amp; team — go Pro from $19.99/mo, with every future update free.
      </span>
      <button
        onClick={() => navigate("/billing")}
        data-testid="trial-upgrade-btn"
        className="shrink-0 text-[12px] font-semibold px-3 py-1.5 rounded-md bg-blue-600 hover:bg-blue-700 text-white transition-colors"
      >
        Upgrade to Pro
      </button>
      <button onClick={dismiss} data-testid="trial-dismiss-btn" aria-label="Dismiss" className="shrink-0 text-zinc-400 hover:text-white">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
